import { OnsetWithWave } from '../../ecg/types/qrs-onset.type';
import { isType } from '../../plot/utils/laddergram';
import { HOUR, MINUTE } from '../../utils/time';
import { Wave } from '../../wave/types/wave.type';
import { ScatterPoint } from '../types/scatter-point.type';

export const buildScatterPlotData = (
  stripStart: number,
  duration: number,
  onsets: OnsetWithWave[],
): ScatterPoint[] => {
  const timeToTheLeft = Math.max(stripStart - duration / 2, 0);
  const timeToTheRight =
    timeToTheLeft === 0 ? duration : stripStart + duration / 2;
  const filteredRPeaks: ScatterPoint[] = [];

  for (let i = 0; i < onsets.length; i++) {
    const r1 = onsets[i].time;
    const r2 = onsets[i + 1]?.time;
    const wave = onsets[i + 1]?.wave;
    if (r2 > timeToTheLeft && r2 < timeToTheRight && r1 != null && r2 > r1) {
      filteredRPeaks.push({
        timestamp: r2,
        bpm: bpmCeiling(MINUTE / (r2 - r1)),
        wave,
      });
    }
  }

  return filteredRPeaks;
};

const bpmCeiling = (bpm: number) => Math.min(bpm, 300);

export const calculateHolterDuration = (onsets: OnsetWithWave[]) => {
  const minOnset = onsets[0].time;
  const maxOnset = onsets[onsets.length - 1].time;
  return maxOnset - minOnset > HOUR ? HOUR : maxOnset - minOnset;
};

export const isPointBordered = (wave: Wave | undefined) =>
  wave == null ? false : isType(wave.tags, 'premature');
